import { useMatches } from "react-router-dom";

export type RouteHandle = {
	showNavbar?: boolean;
	statusBarOverlay?: boolean;
};

export type RouteHandleFlag = keyof RouteHandle;

export const useRouteHandleFlag = (key: RouteHandleFlag): boolean => {
	const matches = useMatches();
	return matches.some(
		(match) => (match.handle as RouteHandle | undefined)?.[key] === true,
	);
};
